import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../Models/Models/Reports/ReportInfo';
import { AssetClassType } from '../../../Constants/Enums/Domain/Instrument/AssetClassType';
import { IJsonDate } from '../../../System/IJsonDate';
import { ViewType } from '../../../Mapping/PortfolioAnalysis/Investment/Enum/ViewType';

declare var IS_RUNNING_IN_APP_POOL;

export class PortfolioInvestmentReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(hierarchyIds: Array<string>, assetClassType: AssetClassType, asAt: IJsonDate, viewType: ViewType, drillDownModeList: Array<number>, actorId: number): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Investment/PortfolioInvestmentReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyIds: hierarchyIds, assetClassType: assetClassType, asAt: asAt, viewType: viewType, drillDownModeList: drillDownModeList, actorId: actorId }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

